export const HURT_CONSOLING = 'hurtConsoling'
export const SOBBING_SHIELDING = 'sobbingShielding'
